export default __webpack_public_path__ + "static/media/user.d2d9f329.svg";